import { render, staticRenderFns } from "./issuePanel.vue?vue&type=template&id=030e929b&scoped=true"
import script from "./issuePanel.vue?vue&type=script&lang=js"
export * from "./issuePanel.vue?vue&type=script&lang=js"
import style0 from "./issuePanel.vue?vue&type=style&index=0&id=030e929b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030e929b",
  null
  
)

export default component.exports